import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'zc-loader',
  template: `<!-- <div style="background-color: white;height: 100%;flex: 1 1 100%;align-items: center;display: flex;justify-content: center;">
  <img width="100px" src="https://loading.io/spinners/ellipsis/lg.discuss-ellipsis-preloader.gif" />
</div> -->`,
  styles: [``]
})
export class ZcLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
